export default __webpack_public_path__ + "media/images/old_logo-small-7746b22a42d97e896b0bfb36cd074853.png";